"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectConversationSortOrderOption_1 = require("../actions/selectConversationSortOrderOption");
var selectHideDeletedItemsOption_1 = require("../actions/selectHideDeletedItemsOption");
var selectGlobalListViewTypeOption_1 = require("../actions/selectGlobalListViewTypeOption");
var store_1 = require("../store/store");
var owa_choice_group_with_images_1 = require("owa-choice-group-with-images");
var owa_options_core_1 = require("owa-options-core");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var NEWEST_ON_TOP_SVG = require('./newestTopLarge.svg');
var NEWEST_ON_BOTTOM_SVG = require('./newestBottomLarge.svg');
var HIDE_DELETED_ITEMS_SVG = require('./hideDeletedLarge.svg');
var SHOW_DELETED_ITEMS_SVG = require('./showDeletedLarge.svg');
var ConversationsFull = /** @class */ (function (_super) {
    tslib_1.__extends(ConversationsFull, _super);
    function ConversationsFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onListViewTypeChange = function (ev, option) {
            selectGlobalListViewTypeOption_1.default(+option.key);
        };
        _this.onHideDeletedItemsChanged = function (ev, option) {
            selectHideDeletedItemsOption_1.default(option.key === 'true');
        };
        _this.onChangeSortOrder = function (ev, option) {
            selectConversationSortOrderOption_1.default(option.key);
        };
        return _this;
    }
    ConversationsFull.prototype.render = function () {
        var _a = this.props, userOptions = _a.userOptions, optionState = _a.optionState;
        var listViewTypeSelectedKey = owa_options_core_1.getFallbackValueIfNull(optionState.globalListViewType, userOptions.GlobalListViewTypeReact);
        var conversationSortOrderKey = optionState.conversationSortOrder || userOptions.ConversationSortOrderReact;
        var hideDeletedItemsKey = "" + owa_options_core_1.getFallbackValueIfNull(optionState.hideDeletedItems, userOptions.HideDeletedItems);
        return (React.createElement("div", null,
            owa_controls_feature_flags_1.isControlFeatureEnabled('tri-messageListView') && (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + listViewTypeSelectedKey, label: owa_options_strings_1.default.options_messageOrganization_positionLabel, options: [
                    {
                        key: "" + 0 /* Conversation */,
                        text: owa_options_strings_1.default.options_messageOrganization_showAsConversation,
                    },
                    {
                        key: "" + 1 /* Message */,
                        text: owa_options_strings_1.default.options_messageOrganization_showAsMessage,
                    },
                ], onChange: this.onListViewTypeChange })),
            listViewTypeSelectedKey === 0 /* Conversation */ && [
                React.createElement(owa_choice_group_with_images_1.ChoiceGroupWithImages, { key: "sortOrder", selectedKey: conversationSortOrderKey, label: owa_options_strings_1.default.options_conversations_sortOrderLabel, options: [
                        {
                            key: 'ChronologicalNewestOnTop',
                            text: owa_options_strings_1.default.options_conversations_sortOrderTop,
                            imageUri: NEWEST_ON_TOP_SVG,
                            width: 280,
                        },
                        {
                            key: 'ChronologicalNewestOnBottom',
                            text: owa_options_strings_1.default.options_conversations_sortOrderBottom,
                            imageUri: NEWEST_ON_BOTTOM_SVG,
                            width: 280,
                        },
                    ], onChange: this.onChangeSortOrder }),
                React.createElement(owa_choice_group_with_images_1.ChoiceGroupWithImages, { key: "deletedItems", selectedKey: hideDeletedItemsKey, label: owa_options_strings_1.default.options_conversations_deletedItemsLabel, options: [
                        {
                            key: 'false',
                            text: owa_options_strings_1.default.options_conversations_deletedItemsShow,
                            imageUri: SHOW_DELETED_ITEMS_SVG,
                            width: 280,
                        },
                        {
                            key: 'true',
                            text: owa_options_strings_1.default.options_conversations_deletedItemsHide,
                            imageUri: HIDE_DELETED_ITEMS_SVG,
                            width: 280,
                        },
                    ], onChange: this.onHideDeletedItemsChanged }),
            ]));
    };
    ConversationsFull = tslib_1.__decorate([
        react_1.reactive({
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
            optionState: function () { return store_1.default; },
        })
    ], ConversationsFull);
    return ConversationsFull;
}(React.Component));
exports.default = ConversationsFull;
//# sourceMappingURL=ConversationsFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-conversations-option/lib/components/ConversationsFull.js
// module id = 5066
// module chunks = 2